/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import { CreateOrderPage } from '../-components/CreateOrderPage';

export const Route = createFileRoute('/(client)/orders-hub/(pages)/create')({
  component: CreateOrderRoute,
});

function CreateOrderRoute() {
  const { isOrdersHubEnabled } = useFeatures();
  if (!isOrdersHubEnabled) return null;
  return <CreateOrderPage />;
}
